export default {
	footer: {
		'total-received': 'Total received',
		'paid-total': 'Toplam Ödenen',
		'the-difference': 'Fark'
	},
	previous: 'Önceki',
	next: 'Sonraki'
}